/*
 * @Description: 描述...
 * @Author: LiuYongChun
 * @Date: 2020-10-27 17:28:56
 * @LastEditors: LiuYongChun
 * @LastEditTime: 2020-12-09 13:26:56
 */
export enum ChargeTypeEnum {
  '待定' = 0,
  '支付宝' = 1,
  '微信'= 2,
  '对公账户' = 3,
  '赠送' = 4,
  '退款' = 5,
  '对充' = 6,
}

export enum ExamTypeEnum {
  JUDGE = "0", // 判断
  COMPOSE = "2", // 创作
  RADIO = "3", // 单选
  MULTIPLE = "4", // 多选
}

/**
 * @author: LiuYongChun
 * @description: 基础数据类型枚举
 * @param {*}
 * @return {*}
 */
export enum COMMON_DATA_TYPE {
  MANAGE_HELP_MANUAL = 'manage_help_manual', // 帮助分类
  SALES_PHASE = 'sales_phase', // 销售阶段
  QUESTION = 'question', // 题目类型
  KNOWLEDGE = 'knowledge', // 知识点
  FOLLOW_UP_WAY = 'follow_up_way', // 跟进方式
  DIFFICULTY = 'difficulty', // 难易程度
  CUSTOMER_INFO_SOURCE = 'customer_info_source', // 采集渠道
  CSR_IMPORTANCE = 'csr_importance', // 重要程度
  EXPERIENCE = 'experience', // 体验课分类
  CUSTOMER_STATUS = 'customerStatus', // 客户状态
  SEX = 'sex', // 性别
  AGE_RANGE = 'age_range', // 年龄段
  COLLECT_TYPE = 'collect_type', // 采集方式
  GRADE = 'grade', // 年级
  SCHOOL_QUALITY = 'school_quality', // 学校质量
  CourseType = 'CourseType', // 课程类型
}

export default {};
